// Generated by scripts/version.sh
export const APP_VERSION = '1.0.23';
